import { getFormattedPriceWithTaxes } from 'modules/NewClientSales/store/selectors/Summary.selectors.helpers'

export const getLegalTextPenaltyValues = (saleTax, taxFreePenaltyAmount) => {
  const penaltyWithTaxes = getFormattedPriceWithTaxes(taxFreePenaltyAmount, saleTax)
  return {
    taxFree: `${taxFreePenaltyAmount}€ (impuestos no incluídos)`,
    withTaxes: `${penaltyWithTaxes}€`,
  }
}
